import type { Renderer2 } from '@angular/core';
import { DOCUMENT, inject, Injectable, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PreloadService {
	private readonly rendererFactory = inject(RendererFactory2);
	private readonly document = inject<Document>(DOCUMENT);

	private readonly renderer: Renderer2;

	constructor() {
		this.renderer = this.rendererFactory.createRenderer(null, null);
	}

	preloadImage(url: string): void {
		if (!url) return;

		const head = this.document.head;
		const existing = head.querySelector(
			`link[rel="preload"][href="${url}"]`,
		);

		if (existing) return;

		const linkEl = this.renderer.createElement('link');
		this.renderer.setAttribute(linkEl, 'rel', 'preload');
		this.renderer.setAttribute(linkEl, 'as', 'image');
		this.renderer.setAttribute(linkEl, 'href', url);
		this.renderer.setAttribute(linkEl, 'fetchpriority', 'high');
		this.renderer.appendChild(head, linkEl);
	}
}
